import { prepPathWithCDN } from '@/utils/location-helpers'

export const DEFAULT_BACKGROUND_PHOTO = prepPathWithCDN(
  '/profiles/cover/blue.svg',
)
